export default {
      id: "ar-demarches-usage",
      viewBox: "0 0 125 125",
      url: "../dist/images/" + "sprite.svg#ar-demarches-usage",
      toString: function () {
        return this.url;
      }
    }